import * as React from "react";
import { ArrowListItem } from "../../arrow-list/arrow-list-item/arrow-list-item.mjs";
import { Button } from "../../button/button.mjs";
import { Card } from "../../card/card/card.mjs";
import { CardContent } from "../../card/card-content/card-content.mjs";
import { CardTop } from "../../card/card-top/card-top.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Heading } from "../../typography/heading/heading.mjs";
import { useLabels } from "../../helpers/label-provider/use-labels.mjs";
import { Modal } from "../../modal/modal/modal.mjs";
import { ModalCloser } from "../../modal/modal-closer/modal-closer.mjs";
import { ModalContent } from "../../modal/modal-content/modal-content.mjs";
import { ModalHeader } from "../../modal/modal-header/modal-header.mjs";
import { ModalProvider } from "../../modal/modal-provider/modal-provider.mjs";
import { ModalTrigger } from "../../modal/modal-trigger/modal-trigger.mjs";
import { TabsItem } from "../../tabs/tabs-item/tabs-item.mjs";
import { TabModalContext } from "../tab-modal/tab-modal.mjs";
const TabModalItem = (props) => {
  const labels = useLabels();
  const { renderedElement, currentTab, setCurrentTab, variant } = React.useContext(TabModalContext);
  return renderedElement === "tabs" ? /* @__PURE__ */ React.createElement(TabsItem, { ...props }, variant === "light" ? /* @__PURE__ */ React.createElement(Card, { padding: "large" }, /* @__PURE__ */ React.createElement(CardContent, null, /* @__PURE__ */ React.createElement(CardTop, null, props.children))) : props.children) : /* @__PURE__ */ React.createElement(
    ModalProvider,
    {
      key: props.id,
      id: props.id,
      isOpen: currentTab === props.id,
      onToggle: (isOpen) => setCurrentTab(isOpen ? props.id : null),
      isClosable: false
    },
    /* @__PURE__ */ React.createElement(ModalTrigger, null, /* @__PURE__ */ React.createElement(ArrowListItem, { url: "#".concat(props.id) }, props.label)),
    /* @__PURE__ */ React.createElement(Modal, { hasContentComponent: true, isFullScreen: true, "aria-labelledby": "".concat(props.id, "-heading") }, /* @__PURE__ */ React.createElement(ModalHeader, null, /* @__PURE__ */ React.createElement(Grid, { noWrap: true, align: ["middle-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(ModalCloser, null, /* @__PURE__ */ React.createElement(Button, { variant: "secondary", icon: "#arrow-left", text: labels.get("close"), id: "".concat(props.id, "-close-button") }))), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"] }, /* @__PURE__ */ React.createElement(Heading, { className: "h3", id: "".concat(props.id, "-heading") }, props.label)))), /* @__PURE__ */ React.createElement(ModalContent, null, props.children))
  );
};
export {
  TabModalItem
};
